import { useOrg } from '@/contexts/OrgContext';

export type AppUserRole = 'admin' | 'owner' | 'manager' | 'member' | 'viewer';

export function usePermissions() {
  const { currentOrg, isLoading } = useOrg();

  const role: AppUserRole = (currentOrg?.role as AppUserRole) ?? 'viewer';

  return {
    role,
    isLoading,
    isAdmin: role === 'admin',
    canInviteMembers: role === 'admin' || role === 'manager',
    canManageRoles: role === 'admin',
    canSync: role !== 'viewer',
    canWriteData: role !== 'viewer',
  };
}
